import { Typography } from "antd";
import FormsTable from "components/Resources/FormsTable";
import './index.scss';

const { Title } = Typography;

const ResourcesFormsPage = () => {

  return (
    <div className="forms-page">
      <div className="header-title">
        <Title level={4} className="ml-3">Forms</Title>
      </div>
      <div className="content">
        <FormsTable />
      </div>
    </div>
  );
}

export {};

export default ResourcesFormsPage;